import { forwardRef } from '@chakra-ui/react';
import type { HTMLChakraProps } from '@chakra-ui/react';
import { chakra, useMultiStyleConfig } from '@chakra-ui/system';
import { cx } from '@chakra-ui/utils';

import { ContainerStyles, ContainerStylesProvider } from './';
import { BASE_CLASS_NAME } from './className';
import type { ContainerSize, ContainerVariant } from './types';

export type ContainerProps = HTMLChakraProps<'div'> & {
  size?: ContainerSize;
  /**
   * The variant of the Container.
   * The default variant is default.
   * The borderless variant is borderless.
   */
  variant?: ContainerVariant;
};

/**
 * A Container is a container.
 */
export const Container = forwardRef<ContainerProps, 'div'>(
  ({ size, variant, children, className, ...props }, ref) => {
    const containerStyles = useMultiStyleConfig('Container', {
      size,
      variant,
    }) as ContainerStyles;

    return (
      <ContainerStylesProvider value={containerStyles}>
        <chakra.div
          __css={containerStyles.container}
          className={cx(BASE_CLASS_NAME, className)}
          {...props}
          ref={ref}
        >
          {children}
        </chakra.div>
      </ContainerStylesProvider>
    );
  },
);
Container.displayName = 'Container';
